const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');
const { subscribePricingEstimates } = require('../../controllers/admin');

function formatDate (value) {
  return value ? new Date(value).toLocaleString() : '—';
}

function formatDuration (milliseconds) {
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;
  return `${(milliseconds / 1000).toFixed(1)} s`;
}

function outcomeLabel (outcome, errorStatus) {
  if (outcome === 'cache_hit') return 'Cached result';
  if (outcome === 'shared_render') return 'Shared render';
  if (outcome === 'rendered') return 'Fresh render';
  if (outcome === 'rate_limited') return 'Rate limited';
  if (outcome === 'failed') return `Failed${errorStatus ? ` · ${errorStatus}` : ''}`;
  return outcome;
}

const AdminEstimatesPage = component((vnode, emit) => {
  let requestedUserId = null;
  let estimates = [];
  let loading = false;
  let error = null;
  let stopSubscription = null;

  function subscribe (user) {
    stopSubscription?.();
    requestedUserId = user.uid;
    estimates = [];
    loading = true;
    error = null;
    emit('redraw');

    stopSubscription = subscribePricingEstimates(nextEstimates => {
      estimates = nextEstimates;
      loading = false;
      error = null;
      emit('redraw');
    }, reason => {
      loading = false;
      error = reason.message;
      emit('redraw');
    });
  }

  return {
    oninit: ({ attrs: { user } }) => subscribe(user),
    onbeforeupdate: ({ attrs: { user } }) => {
      if (requestedUserId !== user.uid) subscribe(user);
    },
    onremove: () => stopSubscription?.(),
    view: () => {
      return m('section.panel.admin-estimates-page', [
        m(Breadcrumbs, {
          items: [
            { label: 'Admin', href: '/admin' },
            { label: 'Pricing estimates' }
          ]
        }),
        m('h2', 'Pricing estimate checks'),
        m('p.muted', 'Live view of the latest 20 checks, including cache hits and failed attempts.'),
        error && m('p.error', error),
        loading && !estimates.length && m('p.muted', 'Loading estimates…'),
        !loading && !error && !estimates.length && m('p.muted', 'No pricing estimates yet.'),
        estimates.length && m('div.admin-estimates-page__table-wrap',
          m('table.admin-estimates-page__table', [
            m('thead', m('tr', [
              m('th', 'Domain'),
              m('th', 'Checked'),
              m('th', 'Result'),
              m('th', 'Rendered'),
              m('th', 'Cache expires'),
              m('th', 'Render time'),
              m('th', 'Normalized compute')
            ])),
            m('tbody', estimates.map(estimate => m('tr', { key: estimate.id }, [
              m('td', m('a', {
                href: `https://${encodeURIComponent(estimate.domain)}`,
                target: '_blank',
                rel: 'noopener'
              }, estimate.domain)),
              m('td', formatDate(estimate.checkedAt)),
              m('td', outcomeLabel(estimate.outcome, estimate.errorStatus)),
              m('td', formatDate(estimate.renderedAt)),
              m('td', formatDate(estimate.cacheExpiresAt)),
              m('td', formatDuration(estimate.renderDurationMs)),
              m('td', formatDuration(estimate.workerComputeMs))
            ])))
          ])
        )
      ]);
    }
  };
});

module.exports = { AdminEstimatesPage };
